module.exports = __webpack_public_path__ + "static/media/spaghetti_carbonara.a52c0416.jpg";